import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import { isEmpty } from 'lodash';
import {
  selectBusinessAttributes,
  selectIsAuthenticated,
  selectUserAttributes,
} from '../../store/selectors';
import { checkAuthenticatedAction } from '../../store/actions/login';
import styles from './styles';
import MaterialLocationModal from '../MaterialLocationModal';
import { USER_PROFILE_TYPES } from '../../constants';
import {
  editUserProfile,
  getBusinessAttributes,
} from '../../store/actions/userProfile';

const propTypes = {
  classes: PropTypes.shape({
    checkAuthContain: PropTypes.string,
    spinner: PropTypes.string,
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  unAuthenticatedURL: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  onUnknownAuth: PropTypes.func.isRequired,
  noNotification: PropTypes.bool,
  userAttributes: PropTypes.object,
  businessAttributes: PropTypes.object,
  onEditUserProfile: PropTypes.func,
  onGetBusinessAttributes: PropTypes.func,
};

const AuthWrapper = props => {
  const {
    classes,
    children,
    isAuthenticated,
    onUnknownAuth,
    unAuthenticatedURL,
    noNotification,
    userAttributes,
    onEditUserProfile,
    businessAttributes,
    onGetBusinessAttributes,
  } = props;
  // console.log(
  //   '🚀 ~ file: index.js ~ line 55 ~ businessAttributes',
  //   businessAttributes,
  // );
  // console.log('🚀 ~ file: index.js ~ line 41 ~ userAttributes', userAttributes);

  useEffect(() => {
    if (isAuthenticated === null) {
      onUnknownAuth(localStorage.getItem('accessToken'), noNotification);
    }
    if (isEmpty(businessAttributes) && localStorage.getItem('accessToken')) {
      onGetBusinessAttributes(localStorage.getItem('accessToken'));
    }
  }, []);
  const skip = JSON.parse(localStorage.getItem('skipMaterialLocation'));
  if (!skip && 'materialLocation' in businessAttributes) {
    if (!businessAttributes.materialLocation) {
      onEditUserProfile(USER_PROFILE_TYPES.BUSINESS);
      return (
        <MaterialLocationModal isOpen businessNumber={userAttributes.sub} />
      );
    }
  }
  // Authenticated
  if (isAuthenticated === true) {
    return children;
  }

  if (unAuthenticatedURL) {
    // NOT Authenticated
    if (isAuthenticated === false) {
      return <Redirect to={unAuthenticatedURL} />;
    }
    // Unknown Authenticated
    return (
      <div className={classes.checkAuthContain}>
        <CircularProgress className={classes.spinner} />
      </div>
    );
  }
  return null;
};

const mapStateToProps = createStructuredSelector({
  isAuthenticated: selectIsAuthenticated(),
  userAttributes: selectUserAttributes(),
  businessAttributes: selectBusinessAttributes(),
});

const mapDispatchToProps = dispatch => ({
  onUnknownAuth: (accessToken, noNotification) =>
    dispatch(checkAuthenticatedAction(accessToken, noNotification)),
  onEditUserProfile: profileType => dispatch(editUserProfile(profileType)),
  onGetBusinessAttributes: accessToken =>
    dispatch(getBusinessAttributes(accessToken)),
});

AuthWrapper.propTypes = propTypes;

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(AuthWrapper));
